module.exports = __webpack_public_path__ + "static/media/finops.2a6ca06c.png";